import AgeLineChartList from "../../../../../../components/Charts/Ageline/AgeLineChartList";



export default function GetDiseaseChart() {

const chronologicalAge = 62;

const sampleData = [
  { disease: 'Mortality Risk', age: 45 },
  { disease: 'Cardiovascular Risk', age: 55 },
  { disease: 'Disease-free Status', age: 42 },
  { disease: 'Type-2 Diabetes', age: 70 },
];

  return (

      <div style={{ padding: '2rem' }}>
      <AgeLineChartList chronologicalAge={chronologicalAge} data={sampleData} />
    </div>
    
  );
};




